import React from 'react';
import { useLocation } from 'react-router-dom';

export const useLocationChange = (action: any) => {
  const location = useLocation();
  React.useEffect(() => {
    action(location);
  }, [location]);
};
